import { AxiosResponse } from "axios";
import { onpreoClient } from "@onpreo/upsy-daisy/client";
import type { ContactOrRealEstate, ContactOrUser } from "../../api/controllers/search";
import { ContactDocument, RealEstateDocument, UserDocument } from "@onpreo/database";

const search = async (query: string): Promise<AxiosResponse<{ result: ContactOrRealEstate[] }>> => {
    const url = "/api/search";
    return await onpreoClient.post<{ result: ContactOrRealEstate[] }>(url, { query });
};

const searchByEmail = async (query: string): Promise<AxiosResponse<{ result: ContactOrUser[] }>> => {
    const url = "/api/search/email";
    return await onpreoClient.post<{ result: ContactOrUser[] }>(url, { query });
};

const searchByEmailAndVariant = async (query: string, variant: string): Promise<AxiosResponse<{ result: ContactDocument[] }>> => {
    const url = "/api/search/variant-by-email";
    return await onpreoClient.post<{ result: ContactDocument[] }>(url, { query, variant });
};

const searchREs = async (query: string): Promise<AxiosResponse<{ result: RealEstateDocument[] }>> => {
    const url = "/api/search/real-estates";
    return await onpreoClient.post<{ result: RealEstateDocument[] }>(url, { query });
};

const searchREsWithPagination = async (query: string, options: any): Promise<AxiosResponse<{ total: number; realEstates: RealEstateDocument[] }>> => {
    const url = "/api/search/real-estates-with-pagination";
    return await onpreoClient.post<{ total: number; realEstates: RealEstateDocument[] }>(url, { query, options });
};

const searchUsers = async (query: string): Promise<AxiosResponse<{ result: UserDocument[] }>> => {
    const url = "/api/search/users";
    return await onpreoClient.post<{ result: UserDocument[] }>(url, { query });
};

export const searchService = {
    search,
    searchByEmail,
    searchByEmailAndVariant,
    searchREs,
    searchUsers,
    searchREsWithPagination
};
